export const serviceProviderUseOfForceAreaPathName = 'magtanvendelser';
